import { gql } from '@apollo/client'

export const Query = gql`
  query Category($companyId: ID!, $filters: CategoryFilters) {
    categories(companyId: $companyId, filters: $filters) {
      nodes {
        id
        name
        fullname
        color
        totalAssetTypeCount
        totalAssetTypeCost
        totalReturnOnInvestment
        totalRevenue
        parent { id fullname color }
        images {
          id
          url
        }
      }
    }
  }
`
